import React from 'react';

import HeadingH1 from '../UI/Headings/HeadingH1/HeadingH1';

const healthCheck = () => <HeadingH1 size={26} weight="Light" color="Dark">Quicksilver Running</HeadingH1>;

export default healthCheck;


// WEBPACK FOOTER //
// ./src/components/HealthCheck/HealthCheck.js